/* ELORA CARE — cart requests on a storefront opened with `_fd=0` (the myshopify domain while the primary domain is not
   connected). Shopify skips Section Rendering and redirects `/cart…` to the primary domain unless the request carries
   `_fd=0`, so the drawer had nothing to render and the shopper landed on a dead domain. The same-origin cart and
   localization fetches get the flag of the page they were made from; on a normal domain the page has no flag and this
   file does nothing. */
(function () {
  if (!/[?&]_fd=0(?:&|$)/.test(window.location.search) || typeof window.fetch !== 'function') return;
  var origin = window.location.origin;
  var nativeFetch = window.fetch;
  function flag(url) {
    var abs = url.indexOf(origin) === 0 ? url.slice(origin.length) : url;
    if (!/^\/(?:cart|localization)(?:[\/.?]|$)/.test(abs) || /[?&]_fd=/.test(abs)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + '_fd=0';
  }
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') input = flag(input);
      else if (input && typeof input.url === 'string') {
        var flagged = flag(input.url);
        if (flagged !== input.url) input = new Request(flagged, input);
      }
    } catch (e) { /* leave the request untouched */ }
    return nativeFetch.call(this, input, init);
  };
})();
